import { Authentication, BaseDeleteRequest } from './';
import * as t from 'io-ts';

export class DeleteAccountLinkRequest extends BaseDeleteRequest<undefined> {
    constructor(public emailAddress: string) {
        super(`account-links/${encodeURIComponent(emailAddress)}/`, {}, null, t.undefined, Authentication.Login);
    }
}
